import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserEditRightService {

  role_manager: number = 1;
  role_user: number = 2;
  role_reader: number = 3;

  constructor() { }

  getEditRight(role?: number) : boolean {
    let isWithEditRight = false;
    if (role === this.role_manager || role === this.role_user) {
      isWithEditRight = true;
    }
    return isWithEditRight;
  }

}
